'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var createAuctionHouse = require('./operations/createAuctionHouse.cjs');
var createBid = require('./operations/createBid.cjs');
var createListing = require('./operations/createListing.cjs');
var executeSale = require('./operations/executeSale.cjs');
var updateAuctionHouse = require('./operations/updateAuctionHouse.cjs');
var directBuy = require('./operations/directBuy.cjs');
var cancelBid = require('./operations/cancelBid.cjs');
var cancelListing = require('./operations/cancelListing.cjs');
var depositToBuyerAccount = require('./operations/depositToBuyerAccount.cjs');
var directSell = require('./operations/directSell.cjs');
var withdrawFromBuyerAccount = require('./operations/withdrawFromBuyerAccount.cjs');

/**
 * This client allows you to access the underlying Transaction Builders
 * for the write operations of the Auction House module.
 *
 * @see {@link AuctionsClient}
 * @group Module Builders
 * */
class AuctionHouseBuildersClient {
  constructor(metaplex) {
    this.metaplex = metaplex;
  }

  /** {@inheritDoc createBidBuilder} */
  bid(input, options) {
    return createBid.createBidBuilder(this.metaplex, input, options);
  }

  /** {@inheritDoc directBuyBuilder} */
  buy(input, options) {
    return directBuy.directBuyBuilder(this.metaplex, input, options);
  }

  /** {@inheritDoc cancelBidBuilder} */
  cancelBid(input, options) {
    return cancelBid.cancelBidBuilder(this.metaplex, input, options);
  }

  /** {@inheritDoc cancelListingBuilder} */
  cancelListing(input, options) {
    return cancelListing.cancelListingBuilder(this.metaplex, input, options);
  }

  /** {@inheritDoc createAuctionHouseBuilder} */
  createAuctionHouse(input, options) {
    return createAuctionHouse.createAuctionHouseBuilder(this.metaplex, input, options);
  }

  /** {@inheritDoc depositToBuyerAccountBuilder} */
  depositToBuyerAccount(input, options) {
    return depositToBuyerAccount.depositToBuyerAccountBuilder(this.metaplex, input, options);
  }

  /** {@inheritDoc executeSaleBuilder} */
  executeSale(input, options) {
    return executeSale.executeSaleBuilder(this.metaplex, input, options);
  }

  /** {@inheritDoc createListingBuilder} */
  list(input, options) {
    return createListing.createListingBuilder(this.metaplex, input, options);
  }

  /** {@inheritDoc directSellBuilder} */
  sell(input, options) {
    return directSell.directSellBuilder(this.metaplex, input, options);
  }

  /** {@inheritDoc updateAuctionHouseBuilder} */
  updateAuctionHouse(input, options) {
    return updateAuctionHouse.updateAuctionHouseBuilder(this.metaplex, input, options);
  }

  /** {@inheritDoc withdrawFromBuyerAccountBuilder} */
  withdrawFromBuyerAccount(input, options) {
    return withdrawFromBuyerAccount.withdrawFromBuyerAccountBuilder(this.metaplex, input, options);
  }
}

exports.AuctionHouseBuildersClient = AuctionHouseBuildersClient;
//# sourceMappingURL=AuctionHouseBuildersClient.cjs.map
